import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-limit-total",
    styleUrls: ["./limit-total.component.scss"],
    templateUrl: "./limit-total.component.html",
    standalone: false
})
export class FUILimitTotalComponent {
    @Input() public limit: number;
    @Input() public total: number;
}
